<template>
  <artmisads-modal
    :open="true"
    title="Invoice"
    :width="720"
    :onCancel="() => props.setDetailData({})"
    :destroyOnClose="true"
  >
    <a-spin :spinning="spinning">
      <div class="invoice">
        <div class="head">
          <span class="name">Amount to Pay:</span>
          <div class="text">
            <span class="num"> {{AMAZON_CURRENCY_MAPPER[props.detailData.marketplace]}}{{props.detailData.amount}}</span>
            <artmisads-select-button @click="toInvoicePdf">
              <svg class="icon icon-daochu1" aria-hidden="true">
                <use xlink:href="#icon-daochu1"></use>
              </svg>
              Download Invoice
            </artmisads-select-button>
          </div>
        </div>
        <p class="notice">Please fill in the relevant information after completing the bank transfer.</p>
        <div class="input-wrap">
          <a-form>
            <a-form-item
              name="bankAccountName"
              v-bind="validateInfos.bankAccountName"
            >
              <div class="input-item">
                <span class="text">Bank Account Name<span>*</span></span>
                <artmisads-input style="width: 324px;" @blur="() => validate('bankAccountName')" size="middle" v-model:value="modelRef.bankAccountName"/>
              </div>
            </a-form-item>
          </a-form>
          <a-form>
            <a-form-item
              name="bankTransferNo"
              v-bind="validateInfos.bankTransferNo"
            >
              <div class="input-item">
                <span class="text">Bank Transfer NO.<span>*</span></span>
                <artmisads-input style="width: 324px;" @blur="() => validate('bankTransferNo')" size="middle" v-model:value="modelRef.bankTransferNo"/>
              </div>
            </a-form-item>
          </a-form>
        </div>
        <p class="img-notice">Upload Transfer receipt photo</p>
        <div class="upload-img">
          <a-form
            :label-col="{ style: { width: '60px' } }"
            :wrapper-col="{ span: 20 }"
            layout="horizontal"
            style="color: aquamarine"
          >
            <a-form-item>
              <UploadImage
                :configs="{
                  maxCount: 1,
                  maxSize: 2,
                  spin: true,
                }"
                :needCropper="false"
                @upload-file="uploadImg"
                #content
              >
                <div class="upload_part">
                  <div v-if="props.detailData.bankTransferReceiptImageUrl || bankTransferReceiptImageUrl" class="upload-img">
                    <img :src="imgCache(props.detailData.bankTransferReceiptImageUrl || bankTransferReceiptImageUrl)" alt="" />
                  </div>
                  <div v-else class="upload-icon">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-shangchuan-xi"></use>
                    </svg>
                  </div>
                </div>
              </UploadImage>
            </a-form-item>
          </a-form>
        </div>
        <p class="note">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-info"></use>
          </svg>
          For bank transfer, after you submit the transfer information, the payment status will be updated after the ArtemisAds operation team verifies the transfer result.
        </p>
      </div>
    </a-spin>
    <template #footer>
      <div class="btn">
        <artmisads-button @click="() => props.setDetailData({})">Cancel</artmisads-button>
        <artmisads-button type="primary" @click="financeSellerBillingsSubmit">Submit</artmisads-button>
      </div>
    </template>
  </artmisads-modal>
</template>

<script setup>
import { useRouter } from "vue-router";
import { Form } from 'ant-design-vue';
import { ref, reactive } from "vue";
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common';
import { financeApi } from "~/server";
import UploadImage from '@/components/uploadImage.vue'
import { imgCache } from '~/utils'

const router = useRouter();
const props = defineProps(["detailData", 'setDetailData']);
const spinning = ref(false);

const bankTransferReceiptImageUrl = ref('');

const useForm = Form.useForm;
  const modelRef = reactive({
    bankAccountName: props.detailData.bankAccountName,
    bankTransferNo: props.detailData.bankTransferNo,
  });

  const rulesRef = reactive({
    bankAccountName: [{
      required: true,
      message: 'Please fill in required information.',
      trigger: ['blur']
    }],
    bankTransferNo: [{
      required: true,
      message: 'Please fill in required information.',
      trigger: ['blur']
    }]
  });

  const { validate, validateInfos } = useForm(modelRef, rulesRef);

const uploadImg = (res) => {
  try {
    if (res.data.url) {
      bankTransferReceiptImageUrl.value = res.data.url;
    }
  } catch (error) {
    console.log('upload-false')
  }
}

const financeSellerBillingsSubmit = async () => {
  const validateRes = await validate();
  if (!validateRes.errorFields) {
    spinning.value = true;
    let paramsData = {...validateRes, billingId: props.detailData.billingId};
      paramsData.bankTransferReceiptImageUrl = bankTransferReceiptImageUrl.value ||  props.detailData.bankTransferReceiptImageUrl || '';
    const res = await await financeApi.financeSellerBillingsSubmit(paramsData);
    const { success } = res;
    if (success) {
      props.setDetailData({}, '', true);
    }
    spinning.value = false;
  }
};

const financeSellerBillingsDownloadInvoice = async () => {
  const paramsData = { billingId: props.detailData.billingId };
  const res = await financeApi.financeSellerBillingsDownloadInvoice(paramsData);
  const { success, data } = res;
  if (success) {
    window.open(data, '_blank');
  }
}

const toInvoicePdf = () => {
  const { href } = router.resolve({ path: `/seller/invoice-pdf/${props.detailData.billingId}` });
  window.open(href, '_blank');
}


</script>

<style lang="less" scoped>
.invoice {
  .head {
    background: var(--bg-gray-8);
    border-radius: 8px;
    padding: 12px 8px 10px 12px;
    .name {
      font-weight: 500;
      font-size: 13px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 20px;
    }
    .text {
      display: flex;
      justify-content: space-between;
      .num {
        font-weight: 600;
        font-size: 18px;
        color: var(--dark-1);
        letter-spacing: 0.4px;
        line-height: 32px;
      }
      button {
        display: flex;
        svg {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          align-self: center;
        }
      }
    }
  }
  .notice {
    font-weight: 600;
    font-size: 16px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 24px;
    margin-top: 40px;
  }
  .input-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    :deep(.ant-form-item) {
      margin-bottom: 0;
    }
    .input-item {
      display: flex;
      flex-wrap: wrap;
      width: 324px;
      .text {
        color: var(--dark-2);
        font-weight: 500;
        line-height: 18px;
        font-size: 13px;
        margin-bottom: 4px;
        display: flex;
        > span {
          color: var(--red-text);
          margin-left: 3px;
          font-size: 14px;
          font-weight: 600;
          line-height: 18px;
        }
      }
    }
  }
  .img-notice {
    color: var(--dark-2);
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-top: 24px;
  }
  .note {
    line-height: 18px;
    color: var(--dark-3);
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0.3px;
    margin-top: 40px;
    svg {
      width: 14px;
      height: 14px;
      fill: var(--dark-3);
      margin-right: 1px;
      vertical-align: -3px;
    }
  }
  .upload-img {
    margin-top: 4px;
    > img {
      width: 120px;
      height: 120px;
      object-fit: contain;
    }
    :deep(.ant-upload) {
      background-color: var(--bg-gray-6);
      width: 120px;
      height: 120px;
      border-radius: 8px;
      cursor: pointer;
      .upload_part {
        width: 120px;
        height: 120px;
      }
      .upload-icon {
        display: flex;
        justify-content: center;
        height: 100%;
        svg {
          align-self: center;
          width: 32px;
          height: 32px;
          fill: var(--dark-3);
        }
      }
    }
  }
}
</style>
